import { setLoading, showErrorNotification, showNotification } from '.';
import ApiClient from '../../loopback/apiClient';
import {
  DigitalSection,
  DRTActionTypes,
  AppThunk,
  DigitalSurvey,
  DigitalCase,
  PartialBy,
  ADD_DIGITAL_SECTION,
  SET_DIGITAL_SURVEY,
  SET_DIGITAL_SECTIONS,
  SET_DIGITAL_CASES,
  SET_SELECTED_DIGITAL_SECTION,
  DELETE_DIGITAL_SECTION,
  SET_SELECTED_CASE,
  SET_DIGITAL_QUESTIONS,
  ADD_UPDATE_DIGITAL_GROUNDTRUTH,
  DigitalQuestion,
  DigitalGroundTruth,
  SET_DIGITAL_GROUNDTRUTHS,
  DELETE_DIGITAL_GROUNDTRUTH,
  ADD_DIGITAL_CASE,
  DELETE_DIGITAL_CASE,
  UPDATE_DIGITAL_CASE,
  UPDATE_DIGITAL_SECTION,
  DigitalSubmission,
  SET_DIGITAL_SUBMISSIONS,
  ADD_UPDATE_DIGITAL_SUBMISSION,
  DigitalSubmissionMeta,
  SET_DIGITAL_SUBMISSION_META,
  UPDATE_DIGITAL_SUBMISSION_META,
  SET_SELECTED_DIGITAL_SUBMISSION_META,
  SurveySubmissionMeta,
  SET_SURVEY_SUBMISSION_META,
  QuestionCaseSetting,
  ADD_QUESTION_CASE_SETTING,
  SET_QUESTION_CASE_SETTING,
  UPDATE_QUESTION_CASE_SETTING,
  DigitalGroundTruthGroup,
  ADD_DIGITAL_GROUND_TRUTH_GROUP,
  SET_DIGITAL_GROUND_TRUTH_GROUP,
  SET_SELECTED_DIGITAL_GROUND_TRUTH_GROUP,
  // UPDATE_DIGITAL_GROUND_TRUTH_GROUP,
  DELETE_DIGITAL_GROUND_TRUTH_GROUP,
  DigitalSectionScore,
  SET_DIGITAL_SECTION_SCORE,
  SET_DIGITAL_SURVEY_SCORE,
  DigitalSurveyScore,
  CLEAR_DIGITAL_SECTION_SCORE,
  CLEAR_DIGITAL_SURVEY_SCORE,
  SET_DIGITAL_QUESTION_SCORE,
  DigitalQuestionScore,
  CLEAR_DIGITAL_QUESTION_SCORE,
  RESET_DIGITAL_SURVEY,
  QuestionTypeV2,
} from '../types';

export const setQuestionCaseSettings = (payload: QuestionCaseSetting[]): DRTActionTypes => ({
  type: SET_QUESTION_CASE_SETTING,
  payload,
});

const addQuestionCaseSettingRedux = (payload: QuestionCaseSetting): DRTActionTypes => ({
  type: ADD_QUESTION_CASE_SETTING,
  payload,
});

export const addQuestionCaseSetting = (
  qcsetting: PartialBy<Omit<QuestionCaseSetting, 'id'>, 'digitalCaseId'>,
): AppThunk => async (dispatch): Promise<void> => {
  dispatch(setLoading(true));
  const qcs = await ApiClient.addQuestionCaseSetting(qcsetting);
  dispatch(addQuestionCaseSettingRedux(qcs));
  dispatch(setLoading(false));
};

const updateQuestionCaseSettingRedux = (payload: QuestionCaseSetting): DRTActionTypes => ({
  type: UPDATE_QUESTION_CASE_SETTING,
  payload,
});

export const updateQuestionCaseSetting = (
  payload: PartialBy<QuestionCaseSetting, 'digitalCaseId'>,
): AppThunk => async (dispatch): Promise<void> => {
  dispatch(setLoading(true));
  const updatedQcs = await ApiClient.updateQuestionCaseSetting(payload);
  dispatch(updateQuestionCaseSettingRedux(updatedQcs));
  dispatch(setLoading(false));
};

export const bulkSettingsAllCasesPerQuestion = (payload: Omit<QuestionCaseSetting, 'digitalCaseId' | 'id'>): AppThunk => async (dispatch): Promise<void> => {
  dispatch(setLoading(true));
  const addedAndUpdatedSettings = await ApiClient.bulkSettingsAllCasesPerQuestion(payload);
  if (addedAndUpdatedSettings.length > 0) {
    const surveyId = addedAndUpdatedSettings[0].digitalSurveyId;
    const questionCaseSettings = await ApiClient.getQuestionCaseSettings(surveyId);
    dispatch(setQuestionCaseSettings(questionCaseSettings));
  }
  dispatch(setLoading(false));
};

export const bulkSettingsAllQuestionsPerCase = (payload: Omit<QuestionCaseSetting, 'digitalQuestionId' | 'id'>): AppThunk => async (dispatch): Promise<void> => {
  dispatch(setLoading(true));
  const addedAndUpdatedSettings = await ApiClient.bulkSettingsAllQuestionsPerCase(payload);
  if (addedAndUpdatedSettings.length > 0) {
    const surveyId = addedAndUpdatedSettings[0].digitalSurveyId;
    const questionCaseSettings = await ApiClient.getQuestionCaseSettings(surveyId);
    dispatch(setQuestionCaseSettings(questionCaseSettings));
  }
  dispatch(setLoading(false));
};

const addOrUpdateDigitalGT = (payload: DigitalGroundTruth): DRTActionTypes => ({
  type: ADD_UPDATE_DIGITAL_GROUNDTRUTH,
  payload,
});

const setDigitalGroundTruths = (payload: DigitalGroundTruth[]): DRTActionTypes => ({
  type: SET_DIGITAL_GROUNDTRUTHS,
  payload,
});

export const addOrUpdateDigitalGroundTruth = (
  dgt: Omit<DigitalGroundTruth, 'id'>,
): AppThunk => async (dispatch): Promise<void> => {
  const dgtlGroundTruth = await ApiClient.addOrUpdateDigitalGroundTruth(dgt);
  dispatch(addOrUpdateDigitalGT(dgtlGroundTruth));
};

export const fetchDigitalGroundTruths = (
  surveyId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const groundTruths = await ApiClient.getGroundtruthBySurveyId(surveyId);
  dispatch(setDigitalGroundTruths(groundTruths));
};

export const fetchDigitalExerciseGroundTruths = (
  surveyId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const groundTruths = await ApiClient.getExerciseGroundTruth(surveyId);
  dispatch(setDigitalGroundTruths(groundTruths));
};

const deleteDigitalGT = (payload: number): DRTActionTypes => ({
  type: DELETE_DIGITAL_GROUNDTRUTH,
  payload,
});

export const deleteDigitalGroundTruth = (
  dgtId: number,
): AppThunk => async (dispatch): Promise<void> => {
  await ApiClient.deleteDigitalGroundTruth(dgtId);
  dispatch(deleteDigitalGT(dgtId));
};

export const setDigitalCases = (ds: DigitalCase[]): DRTActionTypes => ({
  type: SET_DIGITAL_CASES,
  payload: ds,
});

export const setSelectedCase = (c?: number): DRTActionTypes => ({
  type: SET_SELECTED_CASE,
  payload: c,
});

export const addCase = (c: DigitalCase): DRTActionTypes => ({
  type: ADD_DIGITAL_CASE,
  payload: c,
});

const deleteCase = (caseId: number): DRTActionTypes => ({
  type: DELETE_DIGITAL_CASE,
  payload: caseId,
});

const updateCase = (dcase: DigitalCase): DRTActionTypes => ({
  type: UPDATE_DIGITAL_CASE,
  payload: dcase,
});

export const addDigitalCase = (c: PartialBy<DigitalCase, 'id'>): AppThunk => async (dispatch) => {
  const newCase = await ApiClient.addDigitalCase(c);
  dispatch(addCase(newCase));
  dispatch(setSelectedCase(newCase.id));
  if (newCase.digitalSectionId) {
    // drt has no digital section
    dispatch(bulkSettingsAllQuestionsPerCase({
      digitalCaseId: newCase.id,
      digitalSectionId: newCase.digitalSectionId,
      digitalSurveyId: newCase.digitalSurveyId,
      compulsory: true,
    }));
  }
};

export const deleteDigitalCase = (caseId: number): AppThunk => async (dispatch, getState) => {
  await ApiClient.deleteDigitalCase(caseId);
  await ApiClient.deleteDigitalGroundTruthBy({ digitalCaseId: caseId });
  await ApiClient.BulkDeleteQuestionCaseSettingBy({ digitalCaseId: caseId });
  const state = getState();
  dispatch(setSelectedCase(state.SurveyData.digitalCases.allIds[0]));
  dispatch(deleteCase(caseId));
  if (state.SurveyData.survey) {
    dispatch(fetchDigitalGroundTruths(state.SurveyData.survey?.id));
  }
};

export const updateDigitalCase = (dCase: DigitalCase): AppThunk => async (dispatch) => {
  const updatedCase = await ApiClient.updateDigitalCase(dCase.id, dCase);
  dispatch(updateCase(updatedCase));
  dispatch(setSelectedCase(updatedCase.id));
};

const addSection = (digitalSection: DigitalSection): DRTActionTypes => ({
  type: ADD_DIGITAL_SECTION,
  payload: digitalSection,
});

export const setSelectedDigitalsection = (sectionId?: number): DRTActionTypes => ({
  type: SET_SELECTED_DIGITAL_SECTION,
  payload: sectionId,
});

export const addDigitalSection = (
  digitalSection: Omit<DigitalSection, 'id'>,
): AppThunk => async (dispatch): Promise<void> => {
  const addedSection = await ApiClient.addDigitalSection(digitalSection);
  dispatch(addSection(addedSection));
  dispatch(setSelectedDigitalsection(addedSection.id));
};

export const setDigitalSections = (ds: DigitalSection[]): DRTActionTypes => ({
  type: SET_DIGITAL_SECTIONS,
  payload: ds,
});

const deleteSection = (sectionId: number): DRTActionTypes => ({
  type: DELETE_DIGITAL_SECTION,
  payload: sectionId,
});

const updateSection = (payload: DigitalSection): DRTActionTypes => ({
  type: UPDATE_DIGITAL_SECTION,
  payload,
});

export const setDigitalSurvey = (ds: DigitalSurvey): DRTActionTypes => ({
  type: SET_DIGITAL_SURVEY,
  payload: ds,
});

export const updateDigitalSection = (section: DigitalSection): AppThunk => async (dispatch) => {
  const updatedDigitalSection = await ApiClient.updateDigitalSection(section);
  dispatch(updateSection(updatedDigitalSection));
};

export const updateDigitalSurvey = (survey: DigitalSurvey): AppThunk => async (dispatch) => {
  const updatedDigitalSurvey = await ApiClient.updateDigitalSurvey(survey);
  dispatch(setDigitalSurvey(updatedDigitalSurvey));
};

export const deleteDigitalSection = (
  sectionId: number,
): AppThunk => async (dispatch, getState): Promise<void> => {
  try {
    await ApiClient.deleteDigitalSection(sectionId);
    await ApiClient.deleteDigitalGroundTruthBy({ digitalSectionId: sectionId });
    await ApiClient.BulkDeleteQuestionCaseSettingBy({ digitalSectionId: sectionId });
    await ApiClient.deleteDigitalQuestionBy({ digitalSectionId: sectionId });
    await ApiClient.deleteDigitalSectionScoreBy({ digitalSectionId: sectionId });
    await ApiClient.deleteDigitalQuestionScoreBy({ digitalSectionId: sectionId });
    dispatch(deleteSection(sectionId));
    const state = getState();
    const reduxSec = state.SurveyData.digitalSections;
    dispatch(setSelectedDigitalsection(
      reduxSec.allIds[reduxSec.allIds.length - 1],
    ));
  } catch (err) {
    dispatch(showErrorNotification((err as Error).message));
  }
};

export const setDigitalQuestions = (dgtlQuestions: DigitalQuestion[]): DRTActionTypes => ({
  type: SET_DIGITAL_QUESTIONS,
  payload: dgtlQuestions,
});

export const fetchDigitalQuestions = (
  surveyId: number,
): AppThunk => async (dispatch): Promise<void> => {
  try {
    const dgtlQuestions = await ApiClient.fetchDigitalQuestions(surveyId);
    dispatch(setDigitalQuestions(dgtlQuestions));
  } catch (e) {
    dispatch(showErrorNotification((e as Error).message));
  }
};

export const addDigitalQuestion = (
  dq: Omit<DigitalQuestion, 'id'>,
): AppThunk => async (dispatch, getState) => {
  const addedQuestion = await ApiClient.addDigitalQuestion(dq);
  const state = getState();
  const dSurveyId = state.SurveyData.survey?.id;
  if (dSurveyId) {
    dispatch(fetchDigitalQuestions(dSurveyId));
  }
  if (addedQuestion.digitalSectionId && !addedQuestion.isContextQuestion) {
    // drt has no digital section
    dispatch(bulkSettingsAllCasesPerQuestion({
      digitalQuestionId: addedQuestion.id,
      digitalSectionId: addedQuestion.digitalSectionId,
      digitalSurveyId: addedQuestion.digitalSurveyId,
      compulsory: true,
    }));
  } else if (addedQuestion.digitalSectionId && addedQuestion.isContextQuestion) {
    dispatch(addQuestionCaseSetting({
      digitalQuestionId: addedQuestion.id,
      digitalSectionId: addedQuestion.digitalSectionId,
      digitalSurveyId: addedQuestion.digitalSurveyId,
      compulsory: true,
    }));
  }
};

export const updateDigitalQuestion = (
  dq: DigitalQuestion,
): AppThunk => async (dispatch, getState) => {
  await ApiClient.updateDigitalQuestion(dq);
  const state = getState();
  const dSurveyId = state.SurveyData.survey?.id;
  if (dSurveyId) {
    dispatch(fetchDigitalQuestions(dSurveyId));
  }
  const existingQuestion = state.SurveyData.digitalQuestions.byId[dq.id];
  if ((dq.type === QuestionTypeV2.SingleChoiceWithText
    || dq.type === QuestionTypeV2.MultiChoiceWithText)
    && dq.type !== existingQuestion.type) {
    await ApiClient.deleteDigitalGroundTruthBy({ digitalQuestionId: dq.id });
    if (dSurveyId) {
      dispatch(fetchDigitalGroundTruths(dSurveyId));
    }
  }
};

export const deleteDigitalQuestion = (
  dqId: number,
): AppThunk => async (dispatch, getState) => {
  await ApiClient.deleteDigitalQuestion(dqId);
  await ApiClient.deleteDigitalGroundTruthBy({ digitalQuestionId: dqId });
  await ApiClient.BulkDeleteQuestionCaseSettingBy({ digitalQuestionId: dqId });
  ApiClient.deleteDigitalQuestionScoreBy({ digitalQuestionId: dqId });
  const state = getState();
  const dSurveyId = state.SurveyData.survey?.id;
  if (dSurveyId) {
    dispatch(fetchDigitalQuestions(dSurveyId));
    dispatch(fetchDigitalGroundTruths(dSurveyId));
  }
};

export const fetchFullDigitalSurvey = (
  surveyId: number,
): AppThunk => async (dispatch): Promise<void> => {
  dispatch(setLoading(true));
  const extendedDigitalSurvey = await ApiClient.fetchDigitalSurvey(surveyId);
  const digitalCases = await ApiClient.getDigitalCases(surveyId);
  const questionCaseSettings = await ApiClient.getQuestionCaseSettings(surveyId);
  const { digitalSections, digitalQuestions, ...digitalSurvey } = extendedDigitalSurvey;
  dispatch(setDigitalSurvey(digitalSurvey));
  dispatch(setDigitalSections(digitalSections));
  dispatch(setDigitalQuestions(digitalQuestions));
  dispatch(setDigitalCases(digitalCases));
  dispatch(setQuestionCaseSettings(questionCaseSettings));
  dispatch(setLoading(false));
};

export const resetDigitalSurvey = (): DRTActionTypes => ({
  type: RESET_DIGITAL_SURVEY,
});

const setDigitalSubmissions = (payload: DigitalSubmission[]): DRTActionTypes => ({
  type: SET_DIGITAL_SUBMISSIONS,
  payload,
});

export const fetchUsersDigitalSubmissions = (
  trialId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const digitalSubmissions = await ApiClient.getUsersDigitalSubmissions(trialId);
  dispatch(setDigitalSubmissions(digitalSubmissions));
};

export const fetchInstituteDigitalSubmissions = (
  trialId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const digitalSubmissions = await ApiClient.getInstituteDigitalSubmission(trialId);
  dispatch(setDigitalSubmissions(digitalSubmissions));
};

export const setDigitalSubmissionMeta = (payload: DigitalSubmissionMeta[]): DRTActionTypes => ({
  type: SET_DIGITAL_SUBMISSION_META,
  payload,
});

export const fetchDigitalSubmissionsWithMetas = (
  enrollmentId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const digitalSubmissions = await ApiClient.getDigitalSubmissions(enrollmentId);
  const digitalSubmissionsMeta = await ApiClient.getDigitalSubmissionMetaByEnrollment(enrollmentId);
  dispatch(setDigitalSubmissions(digitalSubmissions));
  dispatch(setDigitalSubmissionMeta(digitalSubmissionsMeta));
};

export const addOrUpdateDigitalSubmission = (submission: DigitalSubmission): DRTActionTypes => ({
  type: ADD_UPDATE_DIGITAL_SUBMISSION,
  payload: submission,
});

export const updateDigitalSubmissionMeta = (payload: DigitalSubmissionMeta): DRTActionTypes => ({
  type: UPDATE_DIGITAL_SUBMISSION_META,
  payload,
});

export const setSelectedDigitalSubmissionMeta = (payload?: number): DRTActionTypes => ({
  type: SET_SELECTED_DIGITAL_SUBMISSION_META,
  payload,
});

export const fetchDigitalSubmissionMeta = (
  trialId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const digitalSubmissionMeta = await ApiClient.getDigitalSubmissionMeta(trialId);
  if (digitalSubmissionMeta) {
    dispatch(setDigitalSubmissionMeta(digitalSubmissionMeta));
  }
};

export const finalizeDigitalSubmissionDRT = (
  trialId: number,
  sectionId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const updatedSubmissionMeta = await ApiClient.finalizeDigitalSubmission(trialId, sectionId, true);
  dispatch(updateDigitalSubmissionMeta(updatedSubmissionMeta));
};

export const finalizeContextSubmission = (
  trialId: number,
  sectionId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const updatedSubmissionMeta = await ApiClient.finalizeDigitalContextQuestion(trialId, sectionId);
  dispatch(updateDigitalSubmissionMeta(updatedSubmissionMeta));
};

export const setSurveySubmissionMeta = (payload: SurveySubmissionMeta): DRTActionTypes => ({
  type: SET_SURVEY_SUBMISSION_META,
  payload,
});

export const fetchSurveySubmissionMeta = (
  enrollmentId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const surveyMeta = await ApiClient.getSurveySubmissionMeta(enrollmentId);
  dispatch(setSurveySubmissionMeta(surveyMeta[0]));
};

export const finalizeSurveySubmissionMeta = (
  enrollmentId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const surveyMeta = await ApiClient.finalizeSurvey(enrollmentId);
  dispatch(setSurveySubmissionMeta(surveyMeta));
};

export const setSelectedDigitalGroundTruthGroup = (selectedId: number | null): DRTActionTypes => ({
  type: SET_SELECTED_DIGITAL_GROUND_TRUTH_GROUP,
  payload: selectedId,
});

const addDigitalGroundTruthGroupRedux = (payload: DigitalGroundTruthGroup): DRTActionTypes => ({
  type: ADD_DIGITAL_GROUND_TRUTH_GROUP,
  payload,
});

export const addDigitalGroundTruthGroup = (payload: Omit<DigitalGroundTruthGroup, 'id'>): AppThunk => async (dispatch): Promise<void> => {
  const addedGTGroup = await ApiClient.addDigitalGTGroup(payload);
  dispatch(addDigitalGroundTruthGroupRedux(addedGTGroup));
  dispatch(setSelectedDigitalGroundTruthGroup(addedGTGroup.id));
  dispatch(showNotification(`Added GroundTruth with id ${addedGTGroup.index}`));
};

// const updateDigitalGroundTruthGroupRedux = (
//  payload: DigitalGroundTruthGroup,
// ): DRTActionTypes => ({
//   type: UPDATE_DIGITAL_GROUND_TRUTH_GROUP,
//   payload,
// });

// export const updateDigitalGroundTruthGroup = (
//   payload: DigitalGroundTruthGroup,
// ): AppThunk => async (dispatch): Promise<void> => {
//   const updatedGTGroup = await ApiClient.updateDigitalGTGroup(payload);
//   dispatch(updateDigitalGroundTruthGroupRedux(updatedGTGroup));
// };

const setDigitalGroundTruthGroupRedux = (payload: DigitalGroundTruthGroup[]): DRTActionTypes => ({
  type: SET_DIGITAL_GROUND_TRUTH_GROUP,
  payload,
});

export const fetchDigitalGroundTruthGroups = (
  surveyId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const gtGroups = await ApiClient.getDigitalGTGroups(surveyId);
  dispatch(setDigitalGroundTruthGroupRedux(gtGroups));
  dispatch(setSelectedDigitalGroundTruthGroup(gtGroups[0]?.id || null));
};

const deleteDigitalGroundTruthGroupRedux = (payload: number): DRTActionTypes => ({
  type: DELETE_DIGITAL_GROUND_TRUTH_GROUP,
  payload,
});

export const deleteDigitalGroundTruthGroup = (
  gtGroupId: number,
): AppThunk => async (dispatch): Promise<void> => {
  await ApiClient.deleteDigitalGTGroup(gtGroupId);
  await ApiClient.deleteDigitalGroundTruthBy({
    digitalGroundTruthGroupId: gtGroupId,
  });
  ApiClient.deleteDigitalSectionScoreBy({ digitalGroundTruthGroupId: gtGroupId });
  ApiClient.deleteDigitalSurveyScores(gtGroupId);
  ApiClient.deleteDigitalQuestionScoreBy({ digitalGroundTruthGroupId: gtGroupId });
  ApiClient.nullifyDigitalGroundTruthGroupId(gtGroupId);
  dispatch(deleteDigitalGroundTruthGroupRedux(gtGroupId));
};

const setDigitalSectionScore = (payload: DigitalSectionScore[]): DRTActionTypes => ({
  type: SET_DIGITAL_SECTION_SCORE,
  payload,
});

export const fetchDigitalSectionScores = (
  surveyId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const sectionScores = await ApiClient.fetchDigitalSectionScores(surveyId);
  dispatch(setDigitalSectionScore(sectionScores));
};

export const clearDigitalSectionScores = (): DRTActionTypes => ({
  type: CLEAR_DIGITAL_SECTION_SCORE,
});

export const addOrUpdateDigitalSectionScore = (payload: Omit<DigitalSectionScore, 'id'>): AppThunk => async (dispatch): Promise<void> => {
  const addedSectionScore = await ApiClient.addOrUpdateDigitalSectionScore(payload);
  dispatch(fetchDigitalSectionScores(addedSectionScore.digitalSurveyId));
};

const setDigitalSurveyScore = (payload: DigitalSurveyScore[]): DRTActionTypes => ({
  type: SET_DIGITAL_SURVEY_SCORE,
  payload,
});

export const fetchDigitalSurveyScores = (
  surveyId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const surveyScores = await ApiClient.fetchDigitalSurveyScores(surveyId);
  dispatch(setDigitalSurveyScore(surveyScores));
};

export const clearDigitalSurveyScores = (): DRTActionTypes => ({
  type: CLEAR_DIGITAL_SURVEY_SCORE,
});

export const addOrUpdateDigitalSurveyScore = (payload: Omit<DigitalSurveyScore, 'id'>): AppThunk => async (dispatch): Promise<void> => {
  const addedSurveyScore = await ApiClient.addOrUpdateDigitalSurveyScore(payload);
  dispatch(fetchDigitalSurveyScores(addedSurveyScore.digitalSurveyId));
};

const setDigitalQuestionScore = (payload: DigitalQuestionScore[]): DRTActionTypes => ({
  type: SET_DIGITAL_QUESTION_SCORE,
  payload,
});

export const fetchDigitalQuestionScores = (
  surveyId: number,
): AppThunk => async (dispatch): Promise<void> => {
  const questionScores = await ApiClient.fetchDigitalQuestionScores(surveyId);
  dispatch(setDigitalQuestionScore(questionScores));
};

export const clearDigitalQuestionScores = (): DRTActionTypes => ({
  type: CLEAR_DIGITAL_QUESTION_SCORE,
});

export const addOrUpdateDigitalQuestionScore = (payload: Omit<DigitalQuestionScore, 'id'>): AppThunk => async (dispatch): Promise<void> => {
  const addedQuestionScore = await ApiClient.addOrUpdateDigitalQuestionScore(payload);
  dispatch(fetchDigitalQuestionScores(addedQuestionScore.digitalSurveyId));
};

export const optOutFromSection = (
  trialId: number, sectionId: number, enrollmentId: number, isOptOut: boolean,
): AppThunk => async (dispatch, getState): Promise<void> => {
  const updatedMeta = await ApiClient.optOutFromSection(trialId, sectionId, enrollmentId, isOptOut);
  const state = getState();
  const digitalSubmissionsMap = state.SurveyData.digitalSubmission.byId;
  const filteredSubmissions = Object.values(digitalSubmissionsMap)
    .filter((s) => (s.enrollmentId === enrollmentId && s.digitalSectionId !== sectionId));
  dispatch(setDigitalSubmissions(filteredSubmissions));
  dispatch(updateDigitalSubmissionMeta(updatedMeta));
};
